export const environment = {
    apiUrl: 'https://world-forge.annahid.com/api/',
    production: false
};
